import { create } from './deferred';
import type { RechargeEligibilityInfo } from '../services/src/apis/common.api.types';
import { CommonApis } from '../services/src/apis/common.api'
import { prepareTokenDeferred } from './account';

export const rechargeInfoDeferred = create<RechargeEligibilityInfo>();

export const getRechargeInfo = () => CommonApis.getUserRechargeInfo().then(packages => {
    rechargeInfoDeferred.resolve(packages)
    return packages;
})

prepareTokenDeferred.promise.then(() => getRechargeInfo());
